import Equalizer from "equalizer/dist/equalizer.min.js";

/**
 * This function equalizes all elements with matching [data-equalize] attribute value.
 */
export default function equalHeights() {
    const attrName = 'equalize';
    const elements = document.querySelectorAll('[data-'+attrName+']');

    let ids = [];

    elements.forEach((element) => {
        const id = element.dataset[attrName];

        if(!ids.includes(id)) {
            ids.push(id);
        }
    });

    for(let i = 0 ; i < ids.length ; i++) {
        Equalizer('[data-'+attrName+'="'+ids[i]+'"]').align();
    }
}